import React, { useEffect, useRef, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { observer } from 'mobx-react'
import Tab, { TabItem } from '@/components/tab/tab'
import { Column, Expaned, MainHeader } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import { layerManage } from '@/utils/layer'
import MemberContent, {
    MEMBER_BALANCE_OPERATIONS,
    MEMBER_BENEFIT_SETTING,
    MEMBER_BINDING_RECORD,
    MEMBER_BLACKLIST,
    MEMBER_BIRTHDAY,
    MEMBER_CARD_RECORD,
    MEMBER_CARD_SETTING,
    MEMBER_CHAIN_COIN_SETTING,
    MEMBER_DISCOUNT_SETTING,
    MEMBER_GROUP,
    MEMBER_IMPORT,
    MEMBER_GROWTH_RULE_SETTING,
    MEMBER_LEVEL,
    MEMBER_LEVEL_CHANGE_RECORD,
    MEMBER_POINTS_SETTING,
    MEMBER_POINTS_OPERATIONS,
    MEMBER_POINTS_COUPON_MALL,
    MEMBER_PRICE_SETTING,
    MEMBER_RECHARGE_RECORD,
    MEMBER_RECHARGE_SETTING,
    MEMBER_SETTING_ASSETS,
    MEMBER_SETTING_BASIC,
    MEMBER_SETTING_CHAIN,
    MEMBER_SETTING_MARKETING,
    MEMBER_SVIP_SETTING,
    MEMBER_SVIP_PURCHASE_RECORD,
} from './router'
import { MemberHeaderActionsTargetContext } from './member-header-actions'

import './member.scss'

const SETTING_CATEGORY_TABS: TabItem[] = [
    {
        id: 0,
        name: '基础设置',
        route: MEMBER_SETTING_BASIC,
        activeRoutes: [
            MEMBER_CARD_SETTING,
            MEMBER_GROUP,
            MEMBER_BIRTHDAY,
            MEMBER_CARD_RECORD,
            MEMBER_BINDING_RECORD,
            MEMBER_BLACKLIST,
            MEMBER_IMPORT,
        ],
        perssion: 4,
    },
    {
        id: 1,
        name: '资产与权益',
        route: MEMBER_SETTING_ASSETS,
        activeRoutes: [
            MEMBER_POINTS_SETTING,
            MEMBER_POINTS_OPERATIONS,
            MEMBER_POINTS_COUPON_MALL,
            MEMBER_RECHARGE_SETTING,
            MEMBER_BALANCE_OPERATIONS,
            MEMBER_BENEFIT_SETTING,
        ],
        perssion: 4,
    },
    {
        id: 2,
        name: '等级与营销',
        route: MEMBER_SETTING_MARKETING,
        activeRoutes: [
            MEMBER_LEVEL,
            MEMBER_GROWTH_RULE_SETTING,
            MEMBER_LEVEL_CHANGE_RECORD,
            MEMBER_DISCOUNT_SETTING,
            MEMBER_PRICE_SETTING,
            MEMBER_SVIP_SETTING,
            MEMBER_SVIP_PURCHASE_RECORD,
        ],
        perssion: 4,
    },
    {
        id: 3,
        name: '连锁能力',
        route: MEMBER_SETTING_CHAIN,
        activeRoutes: [MEMBER_CHAIN_COIN_SETTING],
        perssion: 4,
    },
]

const Member = observer((props: RouteComponentProps) => {
    const cls = (el?: string, m?: string) => getBEMCls('member-manage', el, m)
    const pathnameRef = useRef(props.location.pathname)
    const [headerActionsTarget, setHeaderActionsTarget] = useState<HTMLDivElement | null>(null)
    const activeSettingCategory = SETTING_CATEGORY_TABS.find(item =>
        item.activeRoutes?.includes(props.location.pathname),
    )
    const parentSettingRoute = activeSettingCategory?.route
    const isMemberSettingPath = SETTING_CATEGORY_TABS.some(
        item => item.route === props.location.pathname || item.activeRoutes?.includes(props.location.pathname),
    )
    const pageTitle = props.location.pathname === MEMBER_RECHARGE_RECORD ? '充值记录' : '会员列表'

    useEffect(() => {
        if (pathnameRef.current === props.location.pathname) return

        pathnameRef.current = props.location.pathname
        layerManage.popAll()
    }, [props.location.pathname])

    return (
        <MemberHeaderActionsTargetContext.Provider value={headerActionsTarget}>
            <Column className={cls()}>
                <MainHeader>
                    <div className={cls('navigation')}>
                        {isMemberSettingPath ? (
                            <>
                                {parentSettingRoute ? (
                                    <button
                                        type="button"
                                        className={cls('back-icon')}
                                        aria-label="返回上一级"
                                        title="返回上一级"
                                        onClick={() => props.history.push(parentSettingRoute)}
                                    >
                                        <i className="iconfont icon6zuodanjiantou-16" aria-hidden="true" />
                                    </button>
                                ) : null}
                                <Tab tabList={SETTING_CATEGORY_TABS} itemWidth={96} />
                            </>
                        ) : (
                            <div className={cls('page-title')}>{pageTitle}</div>
                        )}
                    </div>
                    <div ref={setHeaderActionsTarget} className={cls('header-actions')} />
                </MainHeader>
                <Expaned className={cls('content')}>
                    <MemberContent {...props} />
                </Expaned>
            </Column>
        </MemberHeaderActionsTargetContext.Provider>
    )
})

export default Member
